import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventData} from '../types';

import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (_event: NotificationEvent): EventData => {
  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: i18n.t('shared:your_coach'),
    title: i18n.t('notifications:availability_needs_to_be_updated_now.title'),
  };
};
